import {HttpClient, HttpParams} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Resource} from 'app/constants/resource';

import EntityCrudService from 'app/blocks/service/api/entity-service';
import {ICustomGoodsTypeProperty} from 'app/blocks/model/custom-goods-type-property';
import {CustomGoodsTypeProperty} from 'app/blocks/model/custom-goods-type-property';

@Injectable({
    providedIn: 'root'
})
export class CustomGoodsTypePropertyService extends EntityCrudService<ICustomGoodsTypeProperty> {
    constructor(http: HttpClient) {
        super(http, Resource.CUSTOM_GOODS_TYPE_PROPERTIES, (obj?) => new CustomGoodsTypeProperty(obj));
    }
}
